import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="very good support, the app works well without any bug.
            The support dont hesitate to give free tips to improve the speed and take time in order to help.
            Thanks!"
            author="Lumiére, IL"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="very good support, the app works well without any bug.
            The support dont hesitate to give free tips to improve the speed and take time in order to help.
            Thanks!"
            author="Lumiére, IL"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="very good support, the app works well without any bug.
            The support dont hesitate to give free tips to improve the speed and take time in order to help.
            Thanks!"
            author="Lumiére, IL"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="very good support, the app works well without any bug.
            The support dont hesitate to give free tips to improve the speed and take time in order to help.
            Thanks!"
            author="Lumiére, IL"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="very good support, the app works well without any bug.
            The support dont hesitate to give free tips to improve the speed and take time in order to help.
            Thanks!"
            author="Lumiére, IL"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="very good support, the app works well without any bug.
            The support dont hesitate to give free tips to improve the speed and take time in order to help.
            Thanks!"
            author="Lumiére, IL"
          />
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
